<template>
  <div class="main-content" style="margin-left: 5px">
    <div class="app-main-inner-row">
      <div class="filters">
        <span style="margin-top: 10px">编辑配置项:</span>
      </div>
      <div class="triggers">
        <span>{{ $t('SystemMaintenance.Search') }}</span>
        <el-input
          v-model="likeName"
          :placeholder="$t('SystemMaintenance.PleaseEnterTheBranchOffice')"
          style="width: 200px;margin: 0 10px"
          @input="filterRowData"
        />
        <el-button type="primary" @click="showBranchSelectDialog">...</el-button>
        <el-button type="primary" @click="showEditDialog(true)">{{ $t('common.btn.new') }}</el-button>
        <el-button type="primary" @click="onCopy">{{ $t('CargoMsg.Cargo_Copy') }}</el-button>
        <el-button type="primary" @click="showEditDialog(false)">{{ $t('common.btn.edit') }}</el-button>
        <el-button type="danger" @click="remove">{{ $t('common.btn.delete') }}</el-button>
        <el-button type="primary" @click="filter.pageNum=1;toQuery()">{{ $t('common.btn.refresh') }}</el-button>
      </div>
    </div>
    <div class="section grid-wrapper" style="height: 90%">
      <cargo-ag-grid
        :grid-params.sync="girdParams"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
      />
    </div>
    <div class="pagination-wrapper">
      <cargo-pagination
        :total="total"
        :page.sync="filter.pageNum"
        :limit.sync="filter.pageSize"
        @pagination="manualPage.paginationClick=true;toQuery()"
      />
    </div>
    <!-- 编辑弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="editDialog.visible"
      :title="editDialog.title"
      width="500px"
      :close-on-click-modal="false"
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;">
        <el-form label-width="110px" label-position="left">
          <el-form-item label="isOverrideable">
            <el-radio-group v-model="editDialog.form.overrideable">
              <el-radio :label="true">{{ $t('SystemMaintenance.Yes') }}</el-radio>
              <el-radio :label="false">{{ $t('SystemMaintenance.No') }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="$t('SystemMaintenance.Branch')">
            <el-select v-model="editDialog.form.officeId" filterable :filter-method="dataFilter" @visible-change="initOfficeList">
              <el-option
                v-for="(item) in officeList"
                :key="item.officeId"
                :label="isZh? '[' + item.code + ']' + item.chineseName : '[' + item.code + ']' + item.englishName "
                :value="item.officeId"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('SystemMaintenance.Value')">
            <el-input v-model="editDialog.form.configValue" :filter-chars="false" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button type="primary" @click="save">{{ $t('common.btn.save') }}</el-button>
        <el-button @click="editDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
    <!-- 分公司选择弹窗 -->
    <branch-select-dialog :visible.sync="branchSelectDialog.visible" :value="branchSelectDialog.value" :office-list="officeList" @callback="branchSelectDialog.callback" />
  </div>
</template>

<script>
import { cacheName, cache } from '@/utils/cacheManager'
import { SyncManager } from '@/utils/commonUtil'
import { getConfigList, batchDeleteConfig } from '@/api/sysManage/baseConfig/config'
import { saveOfficeConfigFunc, copyOfficeConfigUrl } from '@/api/user'
import BranchSelectDialog from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/BranchSelectDialog'
import { getLoading4Cxt } from '@/utils/utilBaseElement'

export default {
  name: 'ConfigurationManagementSub',
  components: { BranchSelectDialog },
  props: {
    configId: { type: String, required: true },
    configName: { type: String, required: true }
  },
  data() {
    return {
      isZh: this.$i18n.locale === 'zh',
      officeList: [],
      officeListCopy: [],
      officeMap: new Map(),
      officeCodeMap: new Map(),
      officeEnglishNameMap: new Map(),
      officeChineseNameMap: new Map(),
      syncManager: new SyncManager(),
      manualPage: {
        data: [],
        paginationClick: false
      },
      likeName: '',
      filter: {
        configId: '',
        pageNum: 1,
        pageSize: 50
      },
      total: 0,
      girdParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressRowClickSelection: true,
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: '',
          field: '',
          width: 65,
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        },
        {
          headerName: this.$t('SystemMaintenance.ConfigurationItem'),
          field: 'configId',
          width: 80
        },
        {
          headerName: 'isOverrideable',
          field: 'overrideable',
          width: 120
        },
        {
          headerName: this.$t('SystemMaintenance.Branch'),
          field: 'officeIdStr',
          width: 200
        },
        {
          headerName: this.$t('SystemMaintenance.Value'),
          field: 'value',
          width: 200
        }
      ],
      rowData: [],
      editDialog: {
        visible: false,
        title: '',
        initialForm: null,
        form: {
          uuid: null,
          version: 0,
          officeId: '',
          configName: '',
          configValue: '',
          overrideable: false
        }
      },
      branchSelectDialog: {
        visible: false,
        value: [],
        callback: () => {}
      }
    }
  },
  computed: {
    gridApi() {
      return this.girdParams.api
    }
  },
  watch: {
    configId(newVal) {
      this.filter.configId = newVal
      this.filter.pageNum = 1
      this.syncManager.execute(async() => {
        await this.toQuery()
      })
    }
  },
  async created() {
    await cache.load(cacheName.OFFICE_LIST)
    this.officeList = cache.officeList
    this.officeListCopy = this.officeList
    for (const item of this.officeList) {
      this.officeMap.set(item.officeId, this.isZh ? '[' + item.code + ']' + item.chineseName : '[' + item.code + ']' + item.englishName)
      this.officeCodeMap.set(item.officeId, item.code)
      this.officeEnglishNameMap.set(item.officeId, item.englishName)
      this.officeChineseNameMap.set(item.officeId, item.chineseName)
    }
    this.editDialog.initialForm = this.editDialog.form
  },
  methods: {
    async toQuery() {
      await this.getConfigPage(this.filter).then(res => {
        res.data.list.forEach(p => {
          p.officeIdStr = this.officeMap.get(p.officeId)
          p.code = this.officeCodeMap.get(p.officeId)
          p.chineseName = this.officeChineseNameMap.get(p.officeId)
          p.englishName = this.officeEnglishNameMap.get(p.officeId)
        })
        if (this.gridApi) {
          this.gridApi.setRowData(res.data.list)
        } else {
          this.rowData = res.data.list
        }
        this.filter.pageNum = res.data.pageNum
        this.filter.pageSize = res.data.pageSize
        this.total = res.data.total
        this.gridApi.clearFocusedCell() // 清除选中行
      })
    },
    async getConfigPage(params) {
      if (this.manualPage.paginationClick) {
        this.manualPage.paginationClick = false
      } else {
        await getConfigList(params).then(res => {
          this.manualPage.data = res.data
        })
      }
      const list = []
      const pageNum = this.filter.pageNum
      const pageSize = this.filter.pageSize
      const total = this.manualPage.data.length
      for (let i = (pageNum - 1) * pageSize; i < total && i < pageNum * pageSize; ++i) {
        list.push(this.manualPage.data[i])
      }
      return { data: { list, pageNum, pageSize, total }}
    },
    showEditDialog(isNew) {
      if (!this.configName) {
        this.$message.warning('请选择一项配置定义')
        return
      }
      if (isNew) {
        const form = { ...this.editDialog.initialForm }
        form.configName = this.configName
        this.editDialog.form = form
        this.editDialog.title = this.$t('common.btn.new')
      } else {
        const cell = this.gridOptions.api.getFocusedCell()
        const nodes = this.gridOptions.api.rowModel.rowsToDisplay
        const row = cell ? nodes.find(node => node.rowIndex === cell.rowIndex).data : null
        if (!row) {
          this.$message.warning(this.$t('common.tips.hasOneAtleast'))
          return
        }
        const form = {
          officeId: row.officeId,
          configName: this.configName,
          configValue: row.value,
          overrideable: row.overrideable,
          version: row.version,
          uuid: row.uuid
        }
        this.editDialog.form = form
        this.editDialog.title = this.$t('common.btn.edit')
      }
      this.editDialog.visible = true
    },
    save() {
      const form = this.editDialog.form
      if (!form.officeId) {
        this.$message.warning(this.$t('SystemMaintenance.BranchOfficeCannotBeEmpty'))
        return
      }
      if (!form.configValue) {
        this.$message.warning(this.$t('SystemMaintenance.ValueCannotBeEmpty'))
        return
      }
      if (form.configValue) {
        form.configValue = form.configValue.trim()
      }
      saveOfficeConfigFunc(form).then(res => {
        if (res.data === 'repeatOffice') {
          this.$message.warning(this.$t('SystemMaintenance.TheConfigurationAlreadyExistsCheck'))
        } else {
          this.$message.success(this.$t('common.tips.saveSuccess'))
        }
        if (!form.uuid) {
          this.filter.pageNum = 1
        }
        this.toQuery()
        this.editDialog.visible = false
        this.gridApi.clearFocusedCell() // 清除选中行
      }).catch(() => {
        this.editDialog.visible = false
      })
    },
    remove() {
      const rows = this.gridOptions.api.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      this.$confirm(this.$t('Message.ConfirmDeleteN', [rows.length]), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        const keys = Array.from(rows, p => p.uuid)
        batchDeleteConfig(keys).then(res => {
          this.filter.pageNum = 1
          this.toQuery()
          this.$message.success(this.$t('common.tips.deleteSuccess'))
        })
      }).catch(() => { })
    },
    filterRowData() {
      let likeName = this.likeName
      likeName = String(likeName).trim()
      const likeNames = likeName.split(',')
      this.rowData = this.manualPage.data.filter(item => {
        for (const val of likeNames) {
          if (item.officeIdStr.includes(val)) {
            return true
          }
          if ((item.code && (!!~item.code.indexOf(val) || !!~item.code.toUpperCase().indexOf(val.toUpperCase()))) || (item.chineseName && !!~item.chineseName.indexOf(val)) ||
            (item.englishName && (!!~item.englishName.indexOf(val) || !!~item.englishName.toUpperCase().indexOf(val.toUpperCase())))) {
            return true
          }
        }
        return false
      })
      this.gridOptions.api.refreshCells({ force: true })
    },
    showBranchSelectDialog() {
      this.branchSelectDialog.value = Array.from(this.likeName.trim().split(','), p => Number(p))
      this.branchSelectDialog.callback = val => {
        if (val.length > 0) {
          this.likeName = Array.from(val, p => this.officeMap.get(p)).join(',')
        } else {
          this.likeName = ''
        }
        this.filterRowData()
      }
      this.branchSelectDialog.visible = true
    },
    onCopy() {
      const cell = this.gridOptions.api.getFocusedCell()
      const nodes = this.gridOptions.api.rowModel.rowsToDisplay
      const row = cell ? nodes.find(node => node.rowIndex === cell.rowIndex).data : null
      if (!row) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      this.branchSelectDialog.value = []
      this.branchSelectDialog.callback = val => {
        if (val.length === 0) {
          return
        }
        const form = {
          officeId: row.officeId,
          configName: this.configName,
          configValue: row.value,
          overrideable: row.overrideable,
          version: row.version,
          uuid: row.uuid
        }
        const loading = getLoading4Cxt(this)
        copyOfficeConfigUrl(form, val.join(',')).then(res => {
          if (res.data === 'repeatOffice') {
            this.$message.warning(this.$t('SystemMaintenance.TheConfigurationAlreadyExistsCheck'))
          } else {
            this.$message.success(this.$t('SeaExport.CopySuccess'))
          }
          this.filter.pageNum = 1
          this.toQuery()
          this.gridApi.clearFocusedCell() // 清除选中行
        }).finally(() => {
          loading.close()
        })
      }
      this.branchSelectDialog.visible = true
    },
    dataFilter(val) {
      this.value = val
      if (val) { // val 存在
        this.officeList = this.officeListCopy.filter((item) => {
          if ((item.code && (!!~item.code.indexOf(val) || !!~item.code.toUpperCase().indexOf(val.toUpperCase()))) || (item.chineseName && !!~item.chineseName.indexOf(val)) ||
            (item.englishName && (!!~item.englishName.indexOf(val) || !!~item.englishName.toUpperCase().indexOf(val.toUpperCase())))) {
            return true
          }
        })
      } else { // val为空时，还原数组
        this.officeList = this.officeListCopy
      }
    },
    initOfficeList() {
      this.officeList = cache.officeList
      this.officeListCopy = this.officeList
    }
  }
}
</script>

<style>
</style>
